import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { computed } from "vue";
import { get } from "@vueuse/core";
import { useChangeCase } from "@vueuse/integrations/useChangeCase";
import { IDirectMessage } from "@/clinic/typings";
import { MessageSenderEnum, MessageTypeEnum } from "@/clinic/typings/enums/direct-message";
import ShowTime from "@/clinic/views/DirectMessage/components/common/message/show-time.vue";
import Audio from "./audio.vue";
import Text from "./text.vue";
import Image from "./image.vue";
import Video from "./video.vue";
import Location from "./location.vue";
import Flex from "./flex.vue";

type IContentMessage = {
  message: IDirectMessage;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    message: null
  },
  setup(__props: any) {

const props = __props as {
  message: IDirectMessage;
};

const MessageTypeComponents = {
  Text,
  Audio,
  Image,
  Sticker: Image,
  Video,
  Location,
  Flex,
};

const hasFromClinic = computed((): boolean => props.message?.sender_type == MessageSenderEnum.clinic);

const content = computed((): string => {
  if (props.message?.message_type == MessageTypeEnum.video) return props.message?.preview_image;

  return props.message?.content;
});



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass(["message-content relative", {
      'message-content-from-clinic': _unref(hasFromClinic) && __props.message?.message_type != 'flex',
      'message-content-flex': __props.message?.message_type == 'flex',
    }])
    }, [
      (_openBlock(), _createBlock(_resolveDynamicComponent(MessageTypeComponents[_unref(get)(_unref(useChangeCase)(__props.message?.message_type || '', 'pascalCase'))]), {
        id: __props.message?.id,
        content: _unref(content),
        type: __props.message?.message_type,
        emojis: __props.message?.emojis
      }, null, 8, ["id", "content", "type", "emojis"]))
    ], 2),
    _createVNode(ShowTime, {
      date: __props.message?.created_at,
      class: "ml-1 mr-1 -mb-5 text-xs"
    }, null, 8, ["date"])
  ], 64))
}
}

})